module.exports = __webpack_public_path__ + "static/media/01-homepage.330806ad.png";